import { atom, RecoilState, selector } from 'recoil';
import { TagEditParams } from '../../components_v2/toolbarFilter/tags/Model';
import { Atoggle } from '../global/Toggle';
import { AtomCategory, AtomState } from '../utils/model/Model';

type AContactEditionType = { id: number } & TagEditParams

const AGlobalContactEdition: AtomState<AContactEditionType | undefined> = {
	category: AtomCategory.GLOBAL,
	atom: atom({
		key: 'atom_global_contact_edition', // UNIQUE ID
		default: undefined
	})
};

const AContactEdition: RecoilState<AContactEditionType | undefined> = selector({
	key: 'atom_contact_edition',
	get: ({ get }) => {
		const category: AtomCategory = get(Atoggle);
		return getAtom(category);
	},
	set: ({ get, set }, newValue) => {
		const category: AtomCategory = get(Atoggle);
		set(getAtom(category), newValue);
	}
});

function getAtom(category: AtomCategory): RecoilState<AContactEditionType | undefined> {
	switch (category) {
		case AtomCategory.GLOBAL:
		default:
			return AGlobalContactEdition.atom;
	}
}

export {
	AContactEdition
};

